import React from "react";
import { ModernPinEntry } from "./ModernPinEntry";
import { StatusMessage } from "./StatusMessage";
import { LoadingScreen } from "../LoadingScreen/LoadingScreen";
import { useOrder } from "../../api";

export const PinEntryPageFromOrder = () => {
  // Get the Order ID from the URL in the window
  const orderId = window.location.pathname.split("/")[2];

  // Use React Query hooks
  const {
    data: order,
    isLoading: isLoadingOrder,
    error: orderError,
  } = useOrder(orderId);

  // Show loading screen while fetching order data
  if (isLoadingOrder) {
    return <LoadingScreen />;
  }

  // Show error if order not found or there's an error
  if (orderError || !order) {
    return <StatusMessage status="not-found" />;
  }

  // Handle different order states
  switch (order.state) {
    case "ACCEPTED":
    case "ASSIGNED":
    case "IN TRANSIT":
      return <ModernPinEntry />;

    case "DELIVERED":
      return (
        <StatusMessage status="delivered" orderNumber={order.orderNumber} />
      );

    default:
      return (
        <StatusMessage status="invalid-state" orderNumber={order.orderNumber} />
      );
  }
};
